// extracted by mini-css-extract-plugin
export default {"home":"Lineup_home__X71F4","logo":"Lineup_logo__12KRf","downUp":"Lineup_downUp__Cn1cB"};